import "./assets/styles/styles.css";
import ComponentContainer from "./components/container/Container";
import Navbar from "./components/navbar/Navbar";
import About from "./sections/about/About";
import Contact from "./sections/contact/Contact";
import Cover from "./sections/cover/Cover";
import Footer from "./sections/footer/Footer";
import Projects from "./sections/projects/Projects";
import Skills from "./sections/skills/Skills";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
    return (
        <div>
            <ComponentContainer>
                <Navbar />
                <Cover />
                <About />
                <Skills />
                <Projects />
            </ComponentContainer>
            <Contact />
            <ComponentContainer>
                <Footer />
            </ComponentContainer>
            <ToastContainer />
        </div>
    );
}

export default App;
